module.exports = __webpack_public_path__ + "static/img/solution_png2.3c4a804.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution_png2.jpg
// module id = H6PG
// module chunks = 1